import {Component} from '@angular/core';

@Component({
    selector: 'app-layout',
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.css'],

})
export class AuthLayoutComponent {
}



// WEBPACK FOOTER //
// ./src/app/layouts/auth/auth-layout.component.ts